import React from "react";
import Desktop from ".";

import LobbyGame from "./LobbyGame";
import PopupResultHistoryGameList from "../PopupResultHistoryGameList";
import PopupInfoNews from "../PopupInfoNews";
import PopupHowToPlay from "../PopupHowToPlay";
import DesktopGameFooter from "../DesktopGameFooter";
import PopupTransactionHistory from "../PopupTransactionHistory";

import img_group_close from "@/assets/img/img_group_close.png";

import { changeHowToPlayPcode, toggleHowToPlay, toggleHowToPlayDropdown } from "@/modules/howToPlay";
import { assetImg } from "@/modules/moduleImporter";
import { getAvailableTotoPcodes, getBasePcode, getPcodesByCategory,  getGroupSize, isTotoGame, isTotoGroup } from "@/modules/gamePcode";
import { changeTransactionPage } from "@/modules/transactions";
import { PopupResultHistory, setActiveGame } from "@/modules/commonMobile";
import { changePortraitResultHistoryTab } from "@/modules/commonPopupResultHistory";
import { IGameObjectType, IKeyStringArrayDict } from "@/types/GlobalTypes";

function bannerFragment() {
	const { userdata } = this.state;

	if (!userdata || this.hasActiveGame)
		return null;

	const {
		game: userdataGame
	} = this.state.userdata;

	if (!userdataGame)
		return null;

	const banner1 = userdataGame.properties.filter(item =>
		item.type === "banner" &&
		item.position === "banner-1"
	)[0];

	return (
		<div className="ads">
			{
				banner1
					? <img src={banner1.content} alt="ad" />
					: null
			}
		</div>
	);
}

const lobbyCategories = ["all", "favorites", "fast-tables", "casino", "ball", "dice", "other"];
Object.freeze(lobbyCategories);

/**
 * For use in cachePcodesByCategory()
 * 
 * Format:
 * { category: pcode[] }
 */
let categoryCache: IKeyStringArrayDict = null;

export function groupPcodesByCategory(games: IGameObjectType) {
	if (!games)
		return {};

	const dict = {};

	for (const category of lobbyCategories)
		dict[category] = getPcodesByCategory(games, category);

	return dict;
}

function lobbyCategoryFragment(this: Desktop) {
	if (this.hasActiveGame)
		return null;

	const {
		lobbyGameFilter,
		lang
	} = this.state;

	return (
		<div className="lobby-top-buttons">
			{/* GAME FILTERS: Defaults to All Games */}
			{
				lobbyCategories.map(filter => (
					<div className={
						"tip tip-" +
						(filter + (filter !== "favorites" ? "-games" : "")) +
						(lobbyGameFilter === filter ? " active" : "")
					}
						key={"ltb_" + filter}
						{...{ filter }}
						onClick={this.setLobbyGameFilter}>

						{assetImg("top_icons", (filter === "favorites" ? "favorite" : filter) + "_games.svg")}

						<div>
							{lang["txt_" + filter + (filter !== "favorites" ? "_games" : "")]}
						</div>
					</div>
				))
			}

			{/* HISTORY & ROADMAP */}
			<div className={"tip tip-history " + (this.state.showLobbyRoadmap ? "active" : "")}
				onClick={this.toggleLobbyRoadmap.bind(this)}>
				{assetImg("top_icons", "roadmap.svg")}

				<div>
					{lang["txt_roadmap"]}
				</div>

				<span className="lobby-tooltip">
					{lang["txt_show_all_roadmap"]}
				</span>
			</div>
			<div className={"tip tip-roadmap " + (this.state.showLobbyHistory ? "active" : "")}
				onClick={this.toggleLobbyHistory.bind(this)}>
				{assetImg("top_icons", "history.svg")}

				<div>
					{lang["txt_history"]}
				</div>

				<span className="lobby-tooltip">
					{lang["txt_show_all_history"]}
				</span>
			</div>
		</div>
	);
}

function allTableActivatorFragment(this: Desktop) {
	const { lang, uniqueGamePcodes } = this.state,
		isUniqueGamePcodesEmpty = !uniqueGamePcodes || uniqueGamePcodes.length === 0,
		classList = [
			"lobby-game-preview multibet-dealer",
			(this.glow ? "glow" : ""),
			(isUniqueGamePcodesEmpty ? "empty-game-list" : "")
		].join(" ");

	return (
		<div className={classList}>

			<div className="box-background-dealer">
				{
					assetImg(
						"icons",
						"background-dealer",
						"",
						"special-multitable background-dealer")
				}
			</div>

			<div className="box-dealer">
				{assetImg("icons", "dealer", "", "special-multitable image-dealer")}
			</div>

			<div className="desc">
				{assetImg("icons", "icon-multitable.svg")}
				<div className="game-name">
					{lang["txt_multitable"]}
				</div>
			</div>
			<div className="sl-hover-hidden" onClick={() => { this.renderGame({ special: "all_games" }); }} />
		</div>
	);
}

function gameGroupFragment(this: Desktop) {
	if (!this.state.showLobbyGameGroup)
		return null;

	const
		{ commonLobbyGameProps } = this,
		{ games, activeGameGroup } = this.state;

	const gamePcodes = Object.keys(games);

	const groupGamePcodes = isTotoGroup(activeGameGroup)
		? getAvailableTotoPcodes(gamePcodes)
		: gamePcodes.filter(pcode =>
			getBasePcode(pcode) === activeGameGroup
		);

	return (
		<>
			<div key="sG_overlay"
				className="overlay"
				onClick={this.toggleShowGameGroup.bind(this)}
			/>

			<div key="sG_content"
				className="game-group-container">
				{
					groupGamePcodes
						.map(pcode =>
							<LobbyGame
								key={`lG_g_` + pcode}
								pcode={pcode}
								ingroup={true}

								{...commonLobbyGameProps}
							/>
						)
				}

				<img className="game-group-close-button"
					src={img_group_close}
					onClick={this.toggleShowGameGroup.bind(this)}
					alt="Close group" />
			</div>
		</>
	);
}

/**
 * Lobby game list (only appears when there's no active game)
 */
function lobbyGameListFragment(this: Desktop) {
	const
		{ commonLobbyGameProps } = this,
		{
			favouritedGames,
			fastTableGames,
			gameGroups,
			lobbyGameFilter,

			games,
		} = this.state;

	// console.log("groups: ", gameGroups);
	if (!categoryCache)
		categoryCache = groupPcodesByCategory(games);

	const renderCodes = (
		lobbyGameFilter === "favorites"
			? favouritedGames
			: lobbyGameFilter === "fast-tables"
				? fastTableGames
				: lobbyGameFilter !== "all"
				? categoryCache[lobbyGameFilter]
				: gameGroups
					? Object.keys(gameGroups)
					: []
	);

	return (
		<div className="sl-lobby-container">
			{this.bannerFragment()}

			{this.allTableActivatorFragment()}

			{
				renderCodes.map(code => {
					// console.log("lGLF pcode: " + code);

					if (!gameGroups[code])
						return null;

					const
						pcode = isTotoGroup(code)
							? gameGroups["toto"][0]
							: gameGroups[code][0],
						hasGroup = getGroupSize(gameGroups[code]) > 1;

					// if (!(/^(favorites|fast-tables|all)$/.test(lobbyGameFilter)) &&
					// 	firstNotEmptyGame.category !== lobbyGameFilter)
					// 	return null;

					return <LobbyGame
						key={`lG_` + code}

						{...{
							pcode,
							hasGroup,
							ingroup: false,
							...commonLobbyGameProps
						}}
					/>;
				})
			}

			{this.gameGroupFragment()}
		</div>
	);
}

function transactionHistoryPopupFragment(this: Desktop) {
	if (!this.state.showTransactionHistoryPopup)
		return null;

	const
		{
			lang: langdata,
			showTransactionHistoryLoadingOverlay,
			userdata
		} = this.state,
		{ currency } = userdata.user;

	return (
		<>
			<div
				className="overlay"
				onClick={this.togglePopupTransactionHistory.bind(this)}
			/>

			<div
				className="iframe-container transaction-history">
				<PopupTransactionHistory
					langdata={langdata}
					currency={currency}

					desktop={true}
					mobile={false}

					{...{
						langdata,
						currency,
						...this.state
					}}

					// Common functions
					fetchTransactionHistory={this.fetchTransactionHistory.bind(this)}

					// same as fetchTransactionHistory but without AJAX
					changeTransactionPage={changeTransactionPage.bind(this)}
					togglePopupTransactionHistory={this.togglePopupTransactionHistory.bind(this)}

					// fetchTransactionDetail={this.fetchTransactionDetail.bind(this)}
					toggleTransactionDetail={this.toggleTransactionDetail.bind(this)}
				/>

				{
					showTransactionHistoryLoadingOverlay ? (
						<div className="game-transaction-history-overlay">
							Loading...
						</div>
					) : null
				}
			</div>
		</>
	)
}

function resultHistoryPopupFragment(this: Desktop) {
	if (!this.state.showResultHistory)
		return null;

	const {
		activeGame,
		lang: langdata
	} = this.state,
		activeGamePcode = activeGame.pcode;

	return (
		<>
			<div
				className="overlay"
				onClick={this.togglePopupResultHistory.bind(this)}
			/>

			<div
				className="iframe-container">
				<PopupResultHistoryGameList
					desktop={true}

					{...{
						activeGamePcode,
						langdata,
						...this.state
					}}

					togglePopupResultHistory={this.togglePopupResultHistory.bind(this)}
					orientation="landscape"

					setActiveGame={setActiveGame.bind(this)}
				/>

				<PopupResultHistory
					{...this.state}

					langdata={langdata}

					fetchResultHistory={this.fetchResultHistory.bind(this)}
					desktop={true}
					orientation="landscape"
					changePortraitResultHistoryTab={changePortraitResultHistoryTab.bind(this)}
				/>
			</div>
		</>
	);
}

function infoNewsFragment(this: Desktop) {
	const {
		news,
		showInfoNews
	} = this.state;

	if (!showInfoNews)
		return null;

	return (
		<div>
			<div
				className="overlay"
				onClick={this.toggleInfoNews.bind(this)} />

			<div className="iframe-container">
				<PopupInfoNews
					news={news}
					toggleInfoNews={this.toggleInfoNews.bind(this)}
				/>
			</div>
		</div>
	);
}

function howToPlayPopupFragment(this: Desktop) {
	if (!this.state.showHowToPlay)
		return null;

	const { lang } = this.state;

	return (
		// How To Play Popup
		<PopupHowToPlay
			langdata={lang}
			{...this.state}

			desktop={true}
			mobile={false}
			orientation={"landscape"}

			changeHowToPlayPcode={changeHowToPlayPcode.bind(this)}
			toggleHowToPlay={toggleHowToPlay.bind(this)}
			toggleHowToPlayDropdown={toggleHowToPlayDropdown.bind(this)}
		/>
	);
}

/**
 * Game footer: only if there is at least one active game
 */
function lobbyFooterFragment(this: Desktop) {
	if (this.noActiveGame)
		return null;

	const { maximisedGamePcode } = this.state;

	if (!maximisedGamePcode || isTotoGame(maximisedGamePcode))
		return null;

	return (
		<DesktopGameFooter
			{...{ ...this.state }}

			changeChip={this.changeChip.bind(this)}
			togglePopupTransactionHistory={this.togglePopupTransactionHistory.bind(this)}
			togglePopupResultHistory={this.togglePopupResultHistory.bind(this)}
			toggleInfoNews={this.toggleInfoNews.bind(this)}
			toggleTooltipSettings={this.toggleTooltipSettings.bind(this)}
			howToPlayGamePcode={maximisedGamePcode}
			toggleHowToPlay={toggleHowToPlay.bind(this)}
			updateUserData={this.fetchUserData.bind(this)}
		/>
	);
}

export {
	bannerFragment,
	lobbyCategoryFragment,

	allTableActivatorFragment,
	gameGroupFragment,
	lobbyGameListFragment,

	transactionHistoryPopupFragment,
	resultHistoryPopupFragment,
	infoNewsFragment,
	howToPlayPopupFragment,
	lobbyFooterFragment
};
